///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../../helpers/messages";

export const SelectViewSection = () => {
  return (
    <div
      data-testid="select-view-message"
      className="flex justify-center items-center text-center full-height bg-white analytics-table-width"
    >
      <div>
        <p className="font-bold font-size-16 text-dim-grey mb-0">
          {messages.pleaseSelectALaneCustomerCarrier.defaultMessage}
        </p>
        <p className="font-bold font-size-16 text-dim-grey">
          {messages.toViewDetails.defaultMessage}
        </p>
      </div>
    </div>
  );
};

export default SelectViewSection;
